const Strings = {
  MY_BOOKINGS: {
    SE: 'Mina bokningar',
    EN: 'My bookings'
  },
  MY_LAUNDRY_BOOKINGS: {
    SE: 'Mina tvättbokningar',
    EN: 'My laundry bookings'
  },
  NO: {
    SE: 'Nej',
    EN: 'No'
  },
  YES: {
    SE: 'Ja',
    EN: 'Yes'
  },
  REQUEST_UNBOOK_TIME: {
    SE: 'Avboka tid',
    EN: 'Unbook time'
  },
  REQUEST_UNBOOK_TIME_INFO: {
    SE: 'Är du säker på att du vill avboka tiden?',
    EN: 'Are you sure your wish to unbook the time?'
  },
  LAUNDRY: {
    S: {
      SE: 'Tvättstuga',
      EN: 'Laundry room'
    },
    M: {
      SE: 'Tvättmaskin',
      EN: 'Laundry machine'
    }
  },
  UNBOOK: {
    SE: 'Avboka',
    EN: 'Unbook'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/laundries/MyBookings/strings.js